import { defineMessages } from 'react-intl'


export default defineMessages({
  accept: {
    defaultMessage: 'Accept',
    id: 'consent-prompt-content.accept',
  },

  decline: {
    defaultMessage: 'Decline',
    id: 'consent-prompt-content.decline',
  },
})
